import React from "react";
import { Col, Form, Input, Modal, Row, Select, Spin, theme } from "antd";
import { SUCCESS_COLOR } from "../../constants/color";
import { PATCH, POST } from "../../frameworks/HttpClient";
import { URL_CHEMICAL } from "../../constants/urls";
import useDropdownItem from "../../common/useDropdownItem";
import ErrorMessages from "../../common/ErrorMessages";
import { toFixed } from "../../frameworks/Util";
import _ from "lodash";

export default function AddStockQualityChemicalModal(props) {
  const { open, onClose, target, onUpdate} = props;
  const [loading, setLoading] = React.useState(false);
  const [ errorMessages, setErrorMessages ] = React.useState(null);
  const [form] = Form.useForm();
  const isCreate = target === 'add'
  const [debouncedChemicalQuality, setDebouncedChemicalQuality] = React.useState('');
  const debounceChemicalQuality = React.useCallback(_.debounce((_searchVal) => { setDebouncedChemicalQuality(_searchVal) }, 800), []);

  const [debouncedChemicalTank, setDebouncedChemicalTank] = React.useState('');
  const debounceChemicalTank = React.useCallback(_.debounce((_searchVal) => { setDebouncedChemicalTank(_searchVal) }, 800), []);

  const chemicalQualityTankOptions = useDropdownItem({
    manual: true, 
    url: URL_CHEMICAL.QUALITY_CHEMICAL_TANK , 
    label_renderer: (item) => `${item.name} [${item.chemical_name}]`, 
    value:'id', 
    pagination: true, 
    params: { page_size: 999, name : debouncedChemicalTank
  }})
  const QualityChemicalDropdown = useDropdownItem({manual: true, url: URL_CHEMICAL.QUALITY_CHEMICAL, label: 'name', value:'id', pagination: true, params: { page_size: 999, name : debouncedChemicalQuality} })

  const {
    token: { colorWarning },
  } = theme.useToken();

  const handleOk = async() => {
    setLoading(true)
    setErrorMessages(null)
    try {
      const data = await form.validateFields()
      if(isCreate){
        await POST(URL_CHEMICAL.QUALITY_CHEMICAL_TANK_TRANSACTION, data)
      } else {
        await PATCH(`${URL_CHEMICAL.QUALITY_CHEMICAL_TANK_TRANSACTION}${target.id}/`, data)
      }
      onUpdate();
    } catch (error) {
      setErrorMessages(error.errorMessages)
    } finally {
      setLoading(false)
    }
  }

  React.useEffect(() => {
    if(open){
      setErrorMessages(null)
      chemicalQualityTankOptions.fetchOptions();
      QualityChemicalDropdown.fetchOptions();
      if(isCreate){
        form.resetFields();
      } else {
        form.setFieldsValue({...target,
          amount : toFixed(target.amount, 2),
      })
        // chemicalQualityTankOptions.addOption({name : target.tank_name, id: target.tank, value : target.tank});
        // QualityChemicalDropdown.addOption({name : target.chemical_name, id: target.chemical, value : target.chemical});
      }
    }
  },[open])

  React.useEffect(() => {
    if(open)
    chemicalQualityTankOptions.fetchOptions({});
  },[debouncedChemicalTank])


React.useEffect(() => {
    if(open)
      QualityChemicalDropdown.fetchOptions({});
  },[debouncedChemicalQuality])
	return(
    <Modal
      open={open}
      onCancel={onClose}
      okText={isCreate ? "ตกลง" : "แก้ไข"}
      okButtonProps={{ style: { backgroundColor : isCreate ? SUCCESS_COLOR : colorWarning}, loading: loading }}
      cancelText={"ปิด"}
      cancelButtonProps={{ loading: loading }}
      title={isCreate ? "เพิ่มสต๊อกสารเคมีคุณภาพ" : "แก้ไขสต๊อกสารเคมีคุณภาพ"}
      width={600}
      onOk={handleOk}
    >
      <ErrorMessages message={errorMessages} />
      <Form
        form={form}
        layout={'vertical'}
      >
        <Row>
          <Col span={12}>
            <Form.Item 
              label={'แทงก์เก็บสารเคมีคุณภาพ'} 
              style={{ marginRight : 10}}
              name={"tank"}
              rules={[
                {
                  required: true,
                  message: 'กรุณากรอกข้อมูล'
                },
              ]}
            >
              <Select
                showSearch
                options={chemicalQualityTankOptions.options}
                style={{ width : '100%' }} 
                placeholder={'แทงก์'}
                onSelect={(value, option) => {
                  form.setFieldValue('chemical', option.chemical)
                }}
                filterOption={false}
                disabled={!isCreate}
                notFoundContent={chemicalQualityTankOptions.loading ? <Spin size="small" /> : "-"}
                onSearch={debounceChemicalTank}
                autoComplete="off"
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item 
              label={'Lot No.'} 
              style={{ marginRight : 10}}
              name={"lot_no"}
              rules={[
                {
                  required: true,
                  message: 'กรุณากรอกข้อมูล'
                },
              ]}
            >
              <Input style={{ width : '100%' }} placeholder={'Lot no'} autoComplete="off"/>
            </Form.Item>
          </Col>
          <Col span={16}>
            <Form.Item 
              label={'ชื่อสารเคมี'} 
              style={{marginRight : 10}}
              name={"chemical"}
              rules={[
                {
                  required: true,
                  message: 'กรุณากรอกข้อมูล'
                }
              ]}
            >
              <Select 
                showSearch
                style={{ width : '100%' }} 
                placeholder={'ชื่อสารเคมี'} 
                options={QualityChemicalDropdown.options}
                filterOption={false}
                notFoundContent={QualityChemicalDropdown.loading ? <Spin size="small" /> : "-"}
                onSearch={debounceChemicalQuality}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item 
              label={'น้ำหนัก (Kg)'} 
              style={{marginRight : 10}}
              name={'amount'}
              rules={[
                {
                  required: true,
                  message: 'กรุณากรอกข้อมูล'
                },
              ]}
            >
              <Input style={{ width : '100%' }} placeholder={'น้ำหนัก'} disabled={isCreate ? false : true} autoComplete="off"/>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
)
}